webpackJsonp([185788632171530],{

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.objectPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(10);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _rehypeReact = __webpack_require__(33);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _Mirador = __webpack_require__(45);
	
	var _Mirador2 = _interopRequireDefault(_Mirador);
	
	var _ObjectData = __webpack_require__(34);
	
	var _ObjectData2 = _interopRequireDefault(_ObjectData);
	
	var _ToggleTip = __webpack_require__(61);
	
	var _ToggleTip2 = _interopRequireDefault(_ToggleTip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ObjectTemplate = function (_React$Component) {
	  _inherits(ObjectTemplate, _React$Component);
	
	  function ObjectTemplate() {
	    _classCallCheck(this, ObjectTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ObjectTemplate.prototype.render = function render() {
	    var resource = this.props.data.markdownRemark;
	    var siteTitle = (0, _get2.default)(this.props, 'data.site.siteMetadata.title');
	
	    var renderAst = new _rehypeReact2.default({
	      createElement: _react2.default.createElement,
	      components: {
	        'object-block': _ObjectData2.default,
	        'toggle-tip': _ToggleTip2.default,
	        'mirador-viewer': _Mirador2.default
	      }
	    }).Compiler;
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'main' },
	      _react2.default.createElement(_reactHelmet2.default, { title: resource.frontmatter.title + ' | ' + siteTitle }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        resource.frontmatter.title
	      ),
	      _react2.default.createElement(_Mirador2.default, { manifest: "https://static.artmuseum.princeton.edu/mirador2/?manifest=https://data.artmuseum.princeton.edu/iiif/objects/" + resource.frontmatter.objectid, height: '500px' }),
	      renderAst(resource.htmlAst),
	      _react2.default.createElement(_ObjectData2.default, { objectid: resource.frontmatter.objectid })
	    );
	  };
	
	  return ObjectTemplate;
	}(_react2.default.Component);
	
	exports.default = ObjectTemplate;
	var objectPageQuery = exports.objectPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-object-js-686a0e6f8e40f924fddf.js